export default [
  {
    path: '/app-store',
    name: 'app-store',
    component: () => import(/* webpackChunkName: "app-store" */ './app-store.vue'),
    meta: {
      menuCode: 'appStore',
      menuName: '应用中心',
    },
  },{
    path: '/app-intro/:code',
    name: 'app-intro',
    component: () => import(/* webpackChunkName: "app-intro" */ './app-intro.vue'),
    meta: {
      cachePage: ['/app-store'],
    },
  }
]